import api from "./axios";

export const auth = {
  login: (data) => api.post("/auth/login", data),
};

export const products = {
  list: (params) => api.get("/products", { params }),
  all: () => api.get("/products/all"),
  get: (id) => api.get(`/products/${id}`),
  create: (data) => api.post("/products", data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  stock: (id) => api.get(`/products/${id}/stock`),
  getSaleRates: (id) => api.get(`/products/${id}/sale-rates`),
  getRentRates: (id) => api.get(`/products/${id}/rent-rates`),
  addSaleRate: (id, data) => api.post(`/products/${id}/sale-rates`, data),
  addRentRate: (id, data) => api.post(`/products/${id}/rent-rates`, data),
  currentAdvance: (id) => api.get(`/products/${id}/current-advance`),

  getRentRateBillCount: (productId, rateId) =>
    api.get(`/products/${productId}/rent-rates/${rateId}/bill-count`),

  updateRentRate: (productId, rateId, data) =>
    api.put(`/products/${productId}/rent-rates/${rateId}`, data),

  deleteRentRate: (productId, rateId) =>
    api.delete(`/products/${productId}/rent-rates/${rateId}`),

  getSaleRateBillCount: (productId, rateId) =>
    api.get(`/products/${productId}/sale-rates/${rateId}/bill-count`),

  updateSaleRate: (productId, rateId, data) =>
    api.put(`/products/${productId}/sale-rates/${rateId}`, data),

  deleteSaleRate: (productId, rateId) =>
    api.delete(`/products/${productId}/sale-rates/${rateId}`),

  usage: (id) => api.get(`/products/${id}/usage`),
};

export const customers = {
  list: (params) => api.get("/customers", { params }),
  all: () => api.get("/customers/all"),
  get: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post("/customers", data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  payments: (id) => api.get(`/customers/${id}/payments`),
  holdingItems: (id) => api.get(`/customers/${id}/holding-items`),
  totalAdvance: (id) => api.get(`/customers/${id}/total-advance`),
  unpaidSummary: (id) => api.get(`/customers/${id}/unpaid-summary`),
};

export const suppliers = {
  list: () => api.get("/suppliers"),
  get: (id) => api.get(`/suppliers/${id}`),
  create: (data) => api.post("/suppliers", data),
  update: (id, data) => api.put(`/suppliers/${id}`, data),
  delete: (id) => api.delete(`/suppliers/${id}`),
};

export const purchases = {
  list: (params) => api.get("/purchases", { params }),
  get: (id) => api.get(`/purchases/${id}`),
  create: (data) => api.post("/purchases", data),
  update: (id, data) => api.put(`/purchases/${id}`, data),
  delete: (id) => api.delete(`/purchases/${id}`),
};

export const rentals = {
  list: (params) => api.get("/rentals", { params }),
  get: (id) => api.get(`/rentals/${id}`),
  create: (data) => api.post("/rentals", data),
  update: (id, data) => api.put(`/rentals/${id}`, data),
  delete: (id) => api.delete(`/rentals/${id}`),
};

export const serviceCenter = {
  list: (params) => api.get("/service-center", { params }),
  inService: () => api.get("/service-center/in-service"),
  repairLogs: (id) => api.get(`/service-center/${id}/repair-logs`),
  repairPartial: (id, data) =>
    api.post(`/service-center/${id}/repair-partial`, data),
  markRepaired: (id) => api.post(`/service-center/${id}/repaired`),
  markScrapped: (id, data) => api.post(`/service-center/${id}/scrap`, data),
  byReturn: (rentalReturnId) =>
    api.get(`/service-center/by-return/${rentalReturnId}`),
  bulkRepaired: (rentalReturnId) =>
    api.post(`/service-center/by-return/${rentalReturnId}/repaired`),
};

export const rentalReturns = {
  list: (params) => api.get("/rental-returns", { params }),
  get: (id) => api.get(`/rental-returns/${id}`),
  create: (data) => api.post("/rental-returns", data),
  update: (id, data) => api.put(`/rental-returns/${id}`, data),
  delete: (id) => api.delete(`/rental-returns/${id}`),
};

export const sales = {
  list: (params) => api.get("/sales", { params }),
  get: (id) => api.get(`/sales/${id}`),
  create: (data) => api.post("/sales", data),
  // FIX: added sale return endpoints
  listReturns: (params) => api.get("/sales/returns", { params }),
  createReturn: (data) => api.post("/sales/returns", data),
};

export const scrap = {
  list: (params) => api.get("/scrap", { params }),
  get: (id) => api.get(`/scrap/${id}`),
  create: (data) => api.post("/scrap", data),
};

export const payments = {
  list: (params) => api.get("/payments", { params }),
  record: (data) => api.post("/payments", data),
  update: (id, data) => api.put(`/payments/${id}`, data),
  delete: (id) => api.delete(`/payments/${id}`),
  // FIX: load unpaid bills for bill-picker in the Record Payment modal
  unpaidSales: (customerId) => api.get(`/payments/unpaid-sales/${customerId}`),
  unpaidRentals: (customerId) =>
    api.get(`/payments/unpaid-rentals/${customerId}`),
};

export const inventory = {
  stock: () => api.get("/inventory/stock"),
  productStock: (id) => api.get(`/inventory/stock/${id}`),
};

export const dashboard = {
  stats: (startDate, endDate) =>
    api.get("/dashboard/stats", { params: { startDate, endDate } }),

  topProducts: (limit, startDate, endDate) =>
    api.get("/dashboard/top-products", {
      params: { limit: limit || 5, startDate, endDate },
    }),

  topCustomers: (limit, startDate, endDate) =>
    api.get("/dashboard/top-customers", {
      params: { limit: limit || 5, startDate, endDate },
    }),

  lowStock: () => api.get("/dashboard/low-stock"),
};